import React from 'react'
import { Helmet } from 'react-helmet'
import '../../css/Custom.css'
import banner from '../../img/banners/storage-pharma.jpeg'
export default function StoragePharma() {

  function FadeInSection(props) {
    const [isVisible, setVisible] = React.useState(false);
    const domRef = React.useRef();
    React.useEffect(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
      });
      observer.observe(domRef.current);
    }, []);
    return (
      <div
        className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
        ref={domRef}
      >
        {props.children}
      </div>
    );
  }

  return (
    <section id="cd-intro">
    <Helmet>
            <title>MenaPac | Storage of Pharma Finished Products</title>
          </Helmet>
            <div id="cd-intro-background" className="your_business_page help-page-banner fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover',boxShadow: 'inset 0 0 0 50vw #0000004d',backgroundPosition:'center' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 your_business text-center">
                            <div className="business_content">
                           
                                <h1 className="bannertitle" >Storage of Pharma Finished Products</h1>
                                {/* <p>Search for answers or explore regular help topics below</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <div className="pages_content improvelive" style={{marginBottom:'3%'}}>
            <div className="container">
            <div className="row">
            <div id="primary" className="content-area" style={{float: 'left', width: '100%',marginTop:'2%'}}>
            <main id="main" className="site-main" role="main">
            <div className="entry-content">
              <div className="become_driver im_lives">
                <div className="border_text">
                <FadeInSection id="1">
                  <h5>Storage of Pharma Finished Products</h5>
                  <p>At MENAPAC PHARMA, we provide premium, MOHAP-approved and GDP-compliant warehousing solutions within a strategically located UAE Free Zone—ensuring your finished pharmaceutical products are stored safely, efficiently, and in full regulatory compliance.</p>

                  <p>Our facility is designed to support your supply chain with reliability, flexibility, and peace of mind:</p>

                  <ul>
                    <li>
                      <p><b>High Capacity:</b> Accommodating approximately 10,000 pallet positions to support your growing business needs</p>
                    </li>
                    <li>
                      <p><b>Flexible Storage Terms:</b> Scalable solutions tailored to your operational timelines</p>
                    </li>
                    <li>
                      <p><b>Controlled Conditions:</b> Ambient and Chilled temperature storage aligned precisely with your product requirements</p>
                    </li>
                    <li>
                      <p><b>Strategic Location:</b> Situated in Jebel Ali Free Zone (JAFZA), offering seamless connectivity for regional and international distribution</p>
                    </li>
                  </ul>

                  <p>Partner with MENAPAC PHARMA to benefit from a trusted storage solution that prioritizes product integrity, regulatory excellence, and operational efficiency.</p>
                </FadeInSection>
 </div>
  </div>

  
  </div>
            </main>
            </div>
            </div>
            </div>
            </div>
    </section>
  )
}
